export const FORM_STRINGS = {
  MAX_TEXT_FIELD_LENGTH: 50,
  MAX_TEXTAREA_FIELD_LENGTH: 500,
};
